import { render } from "./Sprint.vue?vue&type=template&id=36ee5f97&scoped=true"
import script from "./Sprint.vue?vue&type=script&lang=js"
export * from "./Sprint.vue?vue&type=script&lang=js"

import "./Sprint.vue?vue&type=style&index=0&id=36ee5f97&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36ee5f97"

export default script